module.exports = __webpack_public_path__ + "static/media/community_image.fb1b8c3f.jpg";